import { useMeetingData } from '@/contexts/MeetingDataContext'
import useRemoteParticipants from '@hooks/useRemoteParticipants'

type RemoteParticipantDisplay = {
  name: string
  initials: string
  isLoading: boolean
}

/**
 * Hook to get remote participant display information
 * Returns name and initials only when participant is present
 * Departed state logic has been removed for 2-user video conference
 */
export const useRemoteParticipantDisplay = (): RemoteParticipantDisplay => {
  const { interlocutorName, isLoading } = useMeetingData()
  const { activeRemoteAttendees } = useRemoteParticipants()

  // Only show participant info when they are actually present
  const participant = activeRemoteAttendees[0]

  // Name resolution (when participant is present)
  const name = interlocutorName ?? participant?.name ?? 'Participant'
  const initials = name
    .split(' ')
    .map((n: string) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)

  return {
    name,
    initials,
    isLoading
  }
}
